import styled from 'styled-components';
import { ReactComponent as RawLiveSVG } from '../../../../assets/icons/icon_live.svg';

export const IconLive = styled(RawLiveSVG)``;